import React, { useState } from "react";
import { createPortal } from "react-dom";
import InsertGRDS from "./InsertGRDS";
import ModifyGRDS from "./ModifyGRDS";

function GRDSSettings({ purchaseOrderHeaderTarget = null }) {
  const [activeTab, setActiveTab] = useState("INSERT");

  return (
    <>
      {purchaseOrderHeaderTarget && createPortal(
        <div className="Form-Design-section-tabs">
          <div className="Form-Design-section-tabs-bar">
            <button
              type="button"
              className={`Form-Design-section-tabs-button ${activeTab === "INSERT" ? "active" : ""}`}
              onClick={() => setActiveTab("INSERT")}
            >
              Insert
            </button>

            <button
              type="button"
              className={`Form-Design-section-tabs-button mode-update ${activeTab === "MODIFY" ? "active" : ""}`}
              onClick={() => setActiveTab("MODIFY")}
            >
              Modify
            </button>
          </div>
        </div>,
        purchaseOrderHeaderTarget,
      )}

      {activeTab === "INSERT" ? (
        <InsertGRDS />
      ) : (
        <ModifyGRDS />
      )}
    </>
  );
}

export default GRDSSettings;
